import {
  Step,
  StepIndicator,
  Stepper,
  StepperProps,
  StepSeparator,
} from '@chakra-ui/stepper'
import React from 'react'
import { StepperVariant } from '~/components/defaults/componentStyles/Stepper.style'

export const EventHistory = ({
  children,
  ...rest
}: Omit<StepperProps, 'index'>) => {
  return (
    <Stepper
      orientation="vertical"
      {...rest}
      variant={StepperVariant.EventHistory}
      index={999}
    >
      {children}
    </Stepper>
  )
}

interface EventHistoryStepProps {
  children: React.ReactNode
}
export const EventHistoryStep = ({ children }: EventHistoryStepProps) => {
  return (
    <Step>
      <StepIndicator />
      <StepSeparator />
      {children}
    </Step>
  )
}
